import { createStore, applyMiddleware } from 'redux';
import { Reducers, CopyrightReducers, ReportReducers } from '../reducers/index';
import createSagaMiddleware from 'redux-saga';
import { adminSaga, CopyrightSaga, ReportSaga } from '../saga/index';
import { composeWithDevTools } from 'redux-devtools-extension';
let sagaMiddleware = createSagaMiddleware();
function defaultStore(initialState) {
	let store = createStore(Reducers, initialState, composeWithDevTools(applyMiddleware(sagaMiddleware)));
	sagaMiddleware.run(adminSaga);
	return store;
}
function copyRightStore(initialState) {
	let store = createStore(CopyrightReducers, initialState, composeWithDevTools(applyMiddleware(sagaMiddleware)));
	sagaMiddleware.run(CopyrightSaga);
	return store;
}
function reportStore(initialState) {
	let store = createStore(ReportReducers, initialState, composeWithDevTools(applyMiddleware(sagaMiddleware)));
	sagaMiddleware.run(ReportSaga);
	return store;
}
export { defaultStore, copyRightStore, reportStore };
